import type { OktaAuth } from '@okta/okta-auth-js';

import { clearOktaSessionInfo } from 'helpers/okta-session';

import Notification from 'components/partials/notification/notification.helper';

export const expiredTokenHandler = (_oktaAuth: OktaAuth): void => {
  clearOktaSessionInfo();

  Notification.flash(
    'Session Expired',
    'info',
    'Your session has expired, please log in again.',
  );
};
